import { changeRequestApiClient } from '@/clients/ChangeRequestAPIClient';
import { ISalesTeam } from '@/data/models/salesTerritory';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetAllowedCRSalesTeamsQuery(
  albumId?: string | number | null,
  crId?: string | number | null
): UseQueryResult<ISalesTeam[] | undefined, Error> {
  return useQuery({
    queryKey: ['allowedCRSalesTeams', albumId, crId],
    queryFn: async () => {
      if (albumId && crId) {
        return await changeRequestApiClient
          .getAllowedSalesTeams(albumId.toString(), crId.toString())
          .then((response) => response.data);
      }
    },
    enabled: albumId != null && crId != null,
    staleTime: Infinity,
  });
}
